import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgInvertMatrix } from '../../fg-math.js';

const invertMatrixDef = {
  type: FgBlockType.InvertMatrix,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", fgInvertMatrix(a));
  }
};

export { invertMatrixDef };
//# sourceMappingURL=invert-matrix.js.map
